if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia(direction) {
        const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        if (!mediaElements.length) return;

        if (direction === 'prev' || direction === 'next') {
          let currentIndex = mediaElements.findIndex(el => el.classList.contains('active'));
          if (currentIndex === -1) currentIndex = 0;

          if (direction === 'prev') {
            currentIndex = (currentIndex - 1 + mediaElements.length) % mediaElements.length;
          } else {
            currentIndex = (currentIndex + 1) % mediaElements.length;
          }

          mediaElements.forEach(el => el.classList.remove('active'));
          const nextActive = mediaElements[currentIndex];
          if (nextActive) {
            nextActive.classList.add('active');
            nextActive.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

            const counter = this.querySelector('.product-media-modal__counter');
            if (counter) {
              counter.textContent = `${currentIndex + 1} / ${mediaElements.length}`;
            }
          }
          return;
        }

        const targetId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        mediaElements.forEach((element) => {
          if (targetId && element.getAttribute('data-media-id') === targetId) {
            element.classList.add('active');
          } else {
            element.classList.remove('active');
          }
        });

        const activeMedia = this.querySelector('.active') || mediaElements[0];
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const activeIndex = mediaElements.indexOf(activeMedia);
          const counter = this.querySelector('.product-media-modal__counter');
          if (counter) {
            counter.textContent = `${activeIndex + 1} / ${mediaElements.length}`;
          }
        }
      }
    }
  );
}

